import { UPDATE_SEAT } from "./types";

const updateSeat = (seat) => ({
  type: UPDATE_SEAT,
  seat,
});

export default updateSeat;
